<div class="my-deviations">
  <!-- Loading -->
  <div class="md-loading" *ngIf="loading">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <!-- Empty -->
  <div class="md-empty" *ngIf="!loading && rows.length === 0">
    <span translate>NO_RECORDS_FOUND</span>
  </div>

  <ng-container *ngIf="!loading && rows.length > 0">
    <div class="md-list">
      <button
        type="button"
        class="md-row"
        *ngFor="let row of rows"
        (click)="openDeviations()"
      >
        <span class="md-status" [ngClass]="'md-status--' + row.status">
          {{ row.statusText | translate }}
        </span>
        <span class="md-count">{{ row.count }}</span>
      </button>
    </div>

    <div class="md-total">
      <span translate>TOTAL</span>
      <span class="md-count">{{ total }}</span>
    </div>
  </ng-container>
</div>
